class ArticleGalleryThumbs extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;

    this._onThumbCapture = this._handleThumbCapture.bind(this);
    this._onThumbClick = this._handleThumbClick.bind(this);

    const captureEvents = 'PointerEvent' in window
      ? ['pointerdown']
      : ['touchstart', 'mousedown'];

    captureEvents.forEach((eventName) => {
      this.addEventListener(eventName, this._onThumbCapture, true);
    });
    this.addEventListener('click', this._onThumbClick);

    whenReady('Swiper', () => {
      this.thumbsSwiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        preventClicks: false,
        preventClicksPropagation: false,
        slideToClickedSlide: false,
        navigation: {
          nextEl: this.querySelector('.gallery-thumbs-next'),
        },
        a11y: true,
      });
    });
  }

  disconnectedCallback() {
    const captureEvents = 'PointerEvent' in window
      ? ['pointerdown']
      : ['touchstart', 'mousedown'];

    captureEvents.forEach((eventName) => {
      this.removeEventListener(eventName, this._onThumbCapture, true);
    });
    this.removeEventListener('click', this._onThumbClick);
  }

  _getThumbIndex(button) {
    const index = parseInt(button.getAttribute('data-gallery-slide'), 10);
    return Number.isNaN(index) ? null : index;
  }

  _handleThumbCapture(event) {
    const button = event.target.closest('[data-gallery-slide]');
    if (!button || !this.contains(button)) return;

    const index = this._getThumbIndex(button);
    if (index === null) return;

    const dialog = document.getElementById('gallery-dialog');
    const gallery = document.querySelector('article-gallery');

    if (dialog?.classList.contains('active')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      gallery?.openToSlide?.(index);
      return;
    }

    gallery?.setOpenIntent?.({ view: 'pages', slideIndex: index });
  }

  _handleThumbClick(event) {
    const button = event.target.closest('[data-gallery-slide]');
    if (!button || !this.contains(button)) return;

    const index = this._getThumbIndex(button);
    if (index === null) return;

    this.setActiveThumb(index);
  }

  setActiveThumb(index) {
    this.querySelectorAll('[data-gallery-slide]').forEach((button) => {
      const isActive = this._getThumbIndex(button) === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

customElements.define('article-gallery-thumbs', ArticleGalleryThumbs);
